export default __webpack_public_path__ + "static/media/Address.d87eab39.svg";